import { Component, Input, OnInit } from "@angular/core";
import { MyUtils } from "src/app/services/my-utils.service";

@Component({
  selector: "app-counter-number",
  templateUrl: "./counter-number.component.html",
  styleUrls: ["./counter-number.component.scss"],
})
export class CounterNumberComponent implements OnInit {
  @Input() counters: any[] = [];

  constructor(public utils: MyUtils) { }

  ngOnInit(): void { }
}
